import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6251290c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-p-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "child-content" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    id: "testDocumentIframe",
    width: "100%",
    height: "100%",
    frameborder: "0"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemImport = _resolveComponent("SystemImport")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SystemImport, {
        selectedFiles: _ctx.files,
        fileType: _ctx.fileType,
        onFileUploader: _ctx.fileUploader
      }, null, 8, ["selectedFiles", "fileType", "onFileUploader"])
    ]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog = false)),
      headerText: _ctx.$t('Squeeze.System.ResultsOfTestDocument'),
      abortButtonText: _ctx.$t('Squeeze.General.Back'),
      width: '87rem',
      showSaveButton: false,
      style: {"overflow":"hidden"}
    }, {
      content: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["show", "headerText", "abortButtonText"])
  ], 64))
}